export const ABOUT_ME_FIELD_NAMES = {
  planText: 'I would like you to know that my plan after graduation is...',
  accomplishmentText: 'Some accomplishments I would like you to be aware of since coming to Boys Town include...',
  activityText: 'These are the activities that I have been involved in while at Boys Town....',
  postGraduationPlanSelection: 'My post-graduation plan is ',
};

const SELECT_OPTION = [{ value: -1, text: 'Select', disabled: true }];

const SHEET_2_COMPLETED_OPTIONS = [
  ...SELECT_OPTION,
  { value: 8, text: 'Sheet was thoughtfully completed by student' },
  { value: 4, text: 'Sheet was completed by student but requires more work' },
  { value: 2, text: 'Sheet completion needs significant improvement' },
  { value: 0, text: 'Sheet was not completed' },
];

const SHEET_2_SUBMITTED_OPTIONS = [
  ...SELECT_OPTION,
  { value: 8, text: 'Sheet was submitted on time' },
  { value: 4, text: 'Sheet was submitted late (within 24 hours of the initial meeting)' },
  { value: 2, text: 'Sheet was submitted significantly late (between 2 to 3 days after the initial meeting)' },
  { value: 0, text: 'Sheet was not submitted (4 days late or not submitted)' },
];

const SHEET_2_SPEAK_OPTIONS = [
  ...SELECT_OPTION,
  { value: 9, text: 'Student can speak clearly to specifics regarding housing, school, work, or military/job corp' },
  { value: 6, text: 'Student was hesitant and did not speak to specifics of their plan, but accepted feedback well' },
  { value: 3, text: 'Student was hesitant and unsure of plan and did not accept feedback well' },
  { value: 0, text: 'Student could not speak about her/his post-graduation plan' },
];

const MODULE_4_SUBMITTED_OPTIONS = [
  ...SELECT_OPTION,
  { value: 10, text: 'Module was submitted on time' },
  { value: 6, text: 'Module was submitted late (within 24 hours after initial meeting)' },
  { value: 3, text: 'Module was submitted significantly late (between 2 to 3 days after initial meeting)' },
  { value: 0, text: 'Module was 4 or more days late or not submitted' },
];

const MODULE_4_COMPLETED_OPTIONS = [
  ...SELECT_OPTION,
  {
    value: 15,
    text: 'Module was thoughtfully completed by student (all 9 activities completely filled out with complete sentences, legible, and relevant answers)',
  },
  {
    value: 10,
    text: 'Module was completed by student but requires more work (7-8 activities completely filled out with complete sentences, legible, and relevant answers)',
  },
  {
    value: 5,
    text: 'Module completion needs significant improvement (6-4 activities completely filled out with needing work on sentence completion, and relevant answers)',
  },
  { value: 0, text: 'Module was not completed (3 or less activities completed or not turned in at all)' },
];

const MODULE_5_SUBMITTED_OPTIONS = [
  ...SELECT_OPTION,
  { value: 10, text: 'Module was submitted on time' },
  { value: 6, text: 'Module was submitted late (within 24 hours after initial meeting)' },
  { value: 3, text: 'Module was submitted significantly late (between 2 to 3 days after initial meeting)' },
  { value: 0, text: 'Module was 4 or more days late or not submitted' },
];

const MODULE_5_COMPLETED_OPTIONS = [
  ...SELECT_OPTION,
  {
    value: 15,
    text: 'Module was thoughtfully completed by student (all 4 activities completely filled out with complete sentences, legible, and relevant answers)',
  },
  {
    value: 10,
    text: 'Module was completed by student but requires more work (all 4 activities completely filled out with needing work on sentence completion, and relevant answers)',
  },
  { value: 5, text: 'Module completion needs significant improvement (only 3 activities completely filled out)' },
  { value: 0, text: 'Module was not completed (2 or less activities completed or not turned in at all)' },
];

const MODULE_6_SUBMITTED_OPTIONS = [
  ...SELECT_OPTION,
  { value: 10, text: 'Module was submitted on time' },
  { value: 6, text: 'Module was submitted late (within 24 hours after initial meeting)' },
  { value: 3, text: 'Module was submitted significantly late (between 2 to 3 days after initial meeting)' },
  { value: 0, text: 'Module was 4 or more days late or not submitted' },
];

const MODULE_6_COMPLETED_OPTIONS = [
  ...SELECT_OPTION,
  {
    value: 15,
    text: 'Module was thoughtfully completed by student (all 5 activities completely filled out with complete sentences, legible, and relevant answers)',
  },
  {
    value: 10,
    text: 'Module was completed by student but requires more work (all 5 activities completely filled out with needing work on sentence completion, and relevant answers)',
  },
  { value: 5, text: 'Module completion needs significant improvement (only 3 to 4 activities completely filled out)' },
  { value: 0, text: 'Module was not completed (2 or less activities completed or not turned in at all)' },
];

const PROFESSIONAL_JUDGMENT_OPTIONS = [
  { value: 0, text: 'Select Likelihood for Success', disabled: true },
  { value: 1, text: 'Highly unlikely' },
  { value: 2, text: 'Unlikely' },
  { value: 3, text: 'Likely' },
  { value: 4, text: 'Highly likely' },
];

function createOptions(values, texts, selectText = 'Select') {
  const options = [...SELECT_OPTION];
  for (let i = 0; i < values.length; i++) {
    options.push({ value: values[i], text: texts[i], disabled: false });
  }
  return options;
}

const COMMUNICATION_VALUES = [6, 4, 2, 0];
const COMMUNICATION_TEXTS = [
  'Expresses thoughts clearly and respectfully; listens actively and responds appropriately.',
  'Communicates effectively with minor issues; listens and responds adequately.',
  'Communication is unclear or occasionally inappropriate; listening skills need work.',
  'Communication is poor, disrespectful, or disruptive; does not listen or respond appropriately.',
];
const COMMUNICATION_OPTIONS = createOptions(COMMUNICATION_VALUES, COMMUNICATION_TEXTS);

const PARTICIPATION_VALUES = [6, 4, 2, 0];
const PARTICIPATION_TEXTS = [
  'Actively participates throughout; contributes meaningfully and stays engaged. Independently takes notes and asks clarifying questions',
  'Participates regularly; contributions are generally relevant. Adults provide minor prompting including notetaking',
  'Participates occasionally; contributions are minimal or off-topic. Family Teachers do most of the talking and notetaking.',
  'Rarely participates; disengaged or disruptive.',
];
const PARTICIPATION_OPTIONS = createOptions(PARTICIPATION_VALUES, PARTICIPATION_TEXTS);

const WILLINGNESS_TO_ACCEPT_FEEDBACK_VALUES = [6, 4, 2, 0];
const WILLINGNESS_TO_ACCEPT_FEEDBACK_TEXTS = [
  'Accepts feedback openly and respectfully; asks questions to demonstrate understanding.',
  'Accepts feedback with minor resistance; makes excuses.',
  'Accepts feedback reluctantly; openly displays resistance (crying, rolling eyes, etc).',
  'Rejects feedback; shows no effort to change or improve behavior.',
];
const WILLINGNESS_TO_ACCEPT_FEEDBACK_OPTIONS = createOptions(WILLINGNESS_TO_ACCEPT_FEEDBACK_VALUES, WILLINGNESS_TO_ACCEPT_FEEDBACK_TEXTS);

const SOCIAL_SKILLS_VALUES = [4, 3, 2, 0];
const SOCIAL_SKILLS_TEXTS = [
  'Greets others appropriately without prompting. Uses spontaneous engagement, participates in appropriate conversations.',
  'Greets others appropriately without prompting. Participates in appropriate conversations.',
  'Greets others after being prompted; conversation is minimal or awkward.',
  'Does not greet others; avoids conversation or is inappropriate/disrespectful.',
];
const SOCIAL_SKILLS_OPTIONS = createOptions(SOCIAL_SKILLS_VALUES, SOCIAL_SKILLS_TEXTS);

const DRESSED_APPROPRIATELY_VALUES = [3, 2, 1, 0];
const DRESSED_APPROPRIATELY_TEXTS = [
  'Attire is fully appropriate for the setting and occasion; neat and clean.',
  'Attire is mostly appropriate; minor issues (wrinkled, leaves coat on, facial hair, jeans, etc.).',
  'Attire is somewhat inappropriate or untidy; needs improvement.',
  'Attire is clearly inappropriate or unkempt for the setting.',
];
const DRESSED_APPROPRIATELY_OPTIONS = createOptions(DRESSED_APPROPRIATELY_VALUES, DRESSED_APPROPRIATELY_TEXTS);

export const SENIOR_PLANNING_2 = {
  SHEET_2: {
    COMPLETED: {
      OPTIONS: [...SHEET_2_COMPLETED_OPTIONS],
    },
    SUBMITTED: {
      OPTIONS: [...SHEET_2_SUBMITTED_OPTIONS],
    },
    SPEAK: {
      OPTIONS: [...SHEET_2_SPEAK_OPTIONS],
    },
  },
  MODULE_4: {
    SUBMITTED: {
      OPTIONS: [...MODULE_4_SUBMITTED_OPTIONS],
    },
    COMPLETED: {
      OPTIONS: [...MODULE_4_COMPLETED_OPTIONS],
    },
  },
  MODULE_5: {
    SUBMITTED: {
      OPTIONS: [...MODULE_5_SUBMITTED_OPTIONS],
    },
    COMPLETED: {
      OPTIONS: [...MODULE_5_COMPLETED_OPTIONS],
    },
  },
  MODULE_6: {
    SUBMITTED: {
      OPTIONS: [...MODULE_6_SUBMITTED_OPTIONS],
    },
    COMPLETED: {
      OPTIONS: [...MODULE_6_COMPLETED_OPTIONS],
    },
  },
  PROFESSIONAL_JUDGMENT: {
    OPTIONS: [...PROFESSIONAL_JUDGMENT_OPTIONS],
  },
  SOCIAL_SKILLS: {
    OPTIONS: [...SOCIAL_SKILLS_OPTIONS],
  },
  DRESSED_APPROPRIATELY: {
    OPTIONS: [...DRESSED_APPROPRIATELY_OPTIONS],
  },
  COMMUNICATION: {
    OPTIONS: [...COMMUNICATION_OPTIONS],
  },
  PARTICIPATION: {
    OPTIONS: [...PARTICIPATION_OPTIONS],
  },
  WILLINGNESS_TO_ACCEPT_FEEDBACK: {
    OPTIONS: [...WILLINGNESS_TO_ACCEPT_FEEDBACK_OPTIONS],
  },
};

export const ROLE = {
  ADMIN: 'ADMIN',
  AFTERCARE_SPECIALIST: 'AFTERCARE_SPECIALIST',
  FHT: 'FHT',
};

export const FILE_HOSTING = {
  TITLE: 'File Hosting',
  RESOURCE: 'Resource',
  NOT_AUTHORIZED: "You're not authorized. Please contact your administrator.",
  NOT_LOGGED_IN: "You're not currently logged in. Redirecting to login page.",
  CLOSE_WINDOW: 'closeWindow',
};

export const DEFAULT_ERROR_MESSAGE_WITH_PLACEHOLDER = 'An unexpected error occurred {placeholder}. Please try again later.';
export const DEFAULT_ERROR_MESSAGE_PLACEHOLDER = '{placeholder}';

export const DefaultErrorMessage = (placeholder = '') => {
  return DEFAULT_ERROR_MESSAGE_WITH_PLACEHOLDER.replace(DEFAULT_ERROR_MESSAGE_PLACEHOLDER, placeholder);
};

export const POST_GRADUATION_OPTION_VALUES = {
  FOUR_YEAR_COLLEGE: '4_year_college',
  TWO_YEAR_COLLEGE: '2_year_college',
  CAREER_TRAINING: 'career_training',
  MILITARY: 'military',
  WORKFORCE: 'workforce',
};

export const POST_GRADUATION_OPTION_LABELS = {
  [POST_GRADUATION_OPTION_VALUES.FOUR_YEAR_COLLEGE]: '4-Year College',
  [POST_GRADUATION_OPTION_VALUES.TWO_YEAR_COLLEGE]: '2-Year College',
  [POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING]: 'Career Training',
  [POST_GRADUATION_OPTION_VALUES.MILITARY]: 'Military',
  [POST_GRADUATION_OPTION_VALUES.WORKFORCE]: 'Workforce',
};

export const POST_GRADUATION_OPTIONS = [
  { value: POST_GRADUATION_OPTION_VALUES.FOUR_YEAR_COLLEGE, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.FOUR_YEAR_COLLEGE] },
  { value: POST_GRADUATION_OPTION_VALUES.TWO_YEAR_COLLEGE, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.TWO_YEAR_COLLEGE] },
  { value: POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING] },
  { value: POST_GRADUATION_OPTION_VALUES.MILITARY, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.MILITARY] },
  { value: POST_GRADUATION_OPTION_VALUES.WORKFORCE, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.WORKFORCE] },
];

export const POST_GRADUATION_OPTIONS_NAMES = POST_GRADUATION_OPTIONS.map((opt) => opt.label);

export const OLD_POST_GRADUATION_OPTIONS = [
  { value: 'Job Corps/AmeriCorps', label: 'Job Corps/AmeriCorps' },
  { value: 'military', label: 'Military' },
  { value: 'post-secondary education', label: 'Post-Secondary Education' },
  { value: 'post-secondary career training', label: 'Post-Secondary Career Training' },
  { value: 'undecided', label: 'Undecided' },
  { value: 'workforce', label: 'Workforce' },
];

export const CAREER_INTEREST_OPTIONS = [
  { value: POST_GRADUATION_OPTION_VALUES.FOUR_YEAR_COLLEGE, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.FOUR_YEAR_COLLEGE] },
  { value: POST_GRADUATION_OPTION_VALUES.TWO_YEAR_COLLEGE, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.TWO_YEAR_COLLEGE] },
  { value: POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING, label: POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING] },
  { value: 'no_additional_schooling_needed', label: 'No additional schooling needed' },
];

export const CAREER_INTEREST_SUBSECTION_FIELDS = [
  { key: 'program', label: 'Program' },
  { key: 'careerInterest', label: 'Career Interest', maxLength: 100, minRows: 1 },
  { key: 'educationOrTrainingNeeded', label: 'Education or Training Needed', maxLength: 200, minRows: 2 },
  { key: 'twoThingsILikeAboutThisCareer', label: 'Two Things I Like About This Career', maxLength: 200, minRows: 2 },
  { key: 'twoChallengesorDownsides', label: 'Two Challenges or Downsides', maxLength: 200, minRows: 2 },
  { key: 'whyThisCareerAppealstoMe', label: 'Why This Career Appeals to Me?', maxLength: 200, minRows: 2 },
];

export const getPostGraduationOptionLabel = (value) => {
  // Prefer POST_GRADUATION_OPTION_LABELS, fallback to searching POST_GRADUATION_OPTIONS and OLD_POST_GRADUATION_OPTIONS
  if (POST_GRADUATION_OPTION_LABELS[value]) return POST_GRADUATION_OPTION_LABELS[value];
  const found = [...POST_GRADUATION_OPTIONS, ...OLD_POST_GRADUATION_OPTIONS].find((opt) => opt.value === value);
  return found ? found.label : value;
};

export const TWO_YEAR_COLLEGE = ['2-Year College', 'Trade/2-year College'];

export const FOUR_YEAR_COLLEGE = ['4-Year College', '4-year College'];

export const COLLEGE_OPTIONS = [TWO_YEAR_COLLEGE, FOUR_YEAR_COLLEGE];

export const EDU = [
  POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.FOUR_YEAR_COLLEGE],
  POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.TWO_YEAR_COLLEGE],
  POST_GRADUATION_OPTION_LABELS[POST_GRADUATION_OPTION_VALUES.CAREER_TRAINING],
];

export const HOUSING_PLAN_OPTIONS = [
  { label: 'SF Housing/Transitional Living', value: 'sf-housing/transitional-living' },
  { label: 'College Dorm', value: 'college-dorm' },
  { label: 'Living with Family or Friends', value: 'living-with-family-or-friends' },
];

export const CAREER_OPTIONS = [
  { value: 'skilled_trades', label: 'Skilled Trades (electricians, plumbers, welders, auto-mechanics)' },
  { value: 'public_service', label: 'Public Service (firefighters, police officers, paramedic)' },
  { value: 'retail_service', label: 'Retail & Service Industries (food service, warehouse, sales)' },
  { value: 'other', label: 'Other' },
];

export const TRANSPORTATION_OPTIONS = [
  { value: 'car', label: 'Car' },
  { value: 'public_transportation', label: 'Public Transportation' },
  { value: 'lyft_uber', label: 'Lyft/Uber' },
  { value: 'bike', label: 'Bike' },
  { value: 'scooter', label: 'Scooter' },
];

export const MILITARY_BRANCH_OPTIONS = [
  { label: 'Army', value: 'army' },
  { label: 'Marine Corps', value: 'marine_corps' },
  { label: 'Navy', value: 'navy' },
  { label: 'Air Force', value: 'air_force' },
  { label: 'Space Force', value: 'space_force' },
  { label: 'Coast Guard', value: 'coast_guard' },
];

export const RELATIONSHIP_OPTIONS = [
  { value: 'teacher', label: 'Teacher/Coach/School Staff' },
  { value: 'fhp_staff', label: 'FHP Staff (Excluding Direct Care Staff)' },
  { value: 'other', label: 'Other' },
];

export const PLANNING_MEETING_FORM_VERSION = 2;

export const AWARD_PAYMENT = {
  TITLE: 'Award Payment Requests',
  NEW_AWARD_PAYMENT_REQUEST: {
    TITLE: 'New Award Payment Request',
    BREADCRUMB_TITLE: 'New Request',
  },
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  DRAFT: 'draft',
  UNDER_REVIEW: 'under_review',
  NEED_MORE_INFORMATION: 'more_info_needed',
  APPROVED: 'approved',
  PAID: 'paid',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  AWARD_PAYMENT_REQUESTS_CACHE: 'awardPaymentRequestsCache',
  ENROLLED_IN_SCHOOL: 'yes',
  NOT_ENROLLED_IN_SCHOOL: 'no',
  EMPLOYED: 'employed',
  NOT_EMPLOYED: 'unemployed',
  LOOKING_FOR_WORK: 'looking',
};

export const SCHOLARSHIPS_COORDINATOR = ['Scholarships Coordinator'];

export const SCHOLARSHIPS_REVIEWER = [
  ...SCHOLARSHIPS_COORDINATOR,
  'Director Successful Futures Program Support',
  'Sr Director Successful Futures Operations',
];

export const FEATURE_SWITCH = {
  AWARD_PAYMENT: 'Award Payment Users',
};

export const AFTERCARE_SPECIALIST_POSITION_CLASSES = new Set(['1347', '2001', '2148', '1534']);

export const NAMES = {
  ALUMNI: 'Alumni',
  SENIORS: 'High School Seniors',
};
